import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

 const redirectToStore = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // ANDROID
  if (/android/i.test(userAgent)) {
    window.location.href =
      "https://play.google.com/store/apps/details?id=com.vondijital.temelden_app&hl=tr";
    return;
  }

  // IOS
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    window.location.href =
      "https://apps.apple.com/tr/app/temelden/id6758143279?l=tr";
    return;
  }

  // WEB (desktop / browser) → direkt App Store
  window.location.href =
    "https://apps.apple.com/tr/app/temelden/id6758143279?l=tr";
};
  const footerData = [
    {
      title: "Hızlı Erişim",
      links: [
        { label: "Ana Sayfa", path: "/" },
        { label: "Projeler", path: "/projects" },
        { label: "Haberler", path: "/" },
        { label: "Makaleler", path: "/articles" },
        { label: "Yatırım", path: "/yatirim" },
        { label: "Hakkımızda", path: "/about" },
        { label: "İletişim", path: "/iletisim" },
      ],
    },
    {
      title: "Kurumsal",
      links: [
        { label: "Yasal Uyarı", path: "/yasal_uyari" },
        { label: "Platform Kullanım Koşulları", path: "/kullanim_kosullari" },
        { label: "Aydınlatma Metni", path: "/aydinlatma_metni" },
        { label: "Çerez Politikası", path: "/cerez_politikasi" },
        { label: "Üyelik Sözleşmesi", path: "/uyelik_sozlesmesi" },
        { label: "İlan Yayınlama Kuralları", path: "/ilan_yayinlama_kurallari" },
        { label: "KVKK Başvuru Formu", path: "/kvkk_basvuru_formu" },
      ],
    },
    {
      title: "Platform",
      links: [
        { label: "Temelden Ödül Sistemi", path: "/odul_sistemi" },
        { label: "S.S.S", path: "/sss" },
        { label: "Müşterilerin Soruları", path: "/sorulan_sorular" },
      ],
    },
  ];

  const SocialIcons = {
    Instagram: () => (
      <a
        href="https://www.instagram.com/temeldencom?igsh=ZTg0Zm54MmY3Zm4="
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: "inline-flex" }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="#E4405F"
          style={styles.icon}
        >
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
        </svg>
      </a>
    ),

    LinkedIn: () => (
      <a
        href="https://tr.linkedin.com/company/von-digital"
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: "inline-flex" }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="#0A66C2"
          style={styles.icon}
        >
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452z" />
        </svg>
      </a>
    ),

  };

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        {footerData.map((section, idx) => (
          <div key={idx} style={styles.column}>
            <h4 style={styles.heading}>{section.title}</h4>
            {section.links.map((link, i) => (
              <div
                key={i}
                onClick={() => handleNavigation(link.path)}
                style={styles.link}
              >
                {link.label}
              </div>
            ))}
          </div>
        ))}

        <div style={styles.column}>
          <h4 style={styles.heading}>Bizi Takip Edin</h4>
          <div style={styles.socialIcons}>
            {Object.values(SocialIcons).map((Icon, idx) => (
              <div key={idx} style={styles.socialLink}>
                <Icon />
              </div>
            ))}
          </div>
        </div>

        <div style={styles.column}>
          <h4 style={styles.heading}>Mobil Uygulama</h4>

          <img
            src="/images/appstore.png"
            alt="App Store"
            style={styles.storeBadge}
            onClick={redirectToStore}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholder-appstore.png";
            }}
          />

          <img
            src="/images/playstore.png"
            alt="Play Store"
            style={styles.storeBadge}
            onClick={redirectToStore}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholder-playstore.png";
            }}
          />
        </div>

        {/* SAĞA EKLENEN YENİ SÜTUN */}
        <div style={styles.column}>
          <h4 style={styles.heading}>Mobil Uygulama Sözleşmeleri</h4>
          <div
            style={styles.link}
            onClick={() => handleNavigation("/mobil_uygulama_kullanici_uyelik_sozlesmesi")}
          >
            Kullanıcı Üyelik Sözleşmesi
          </div>
          <div
            style={styles.link}
            onClick={() => handleNavigation("/mobil_uygulama_aydinlatma_metni")}
          >
            Aydınlatma Metni
          </div>
          <div
            style={styles.link}
            onClick={() =>
              handleNavigation("/mobil_uygulama_ticari_iletisim_aydinlatma_metni")
            }
          >
            Pazarlama Aydınlatma Metni
          </div>
          <div
            style={styles.link}
            onClick={() => handleNavigation("/mobil_uygulama_ticari_elektronik_ileti_onayi")}
          >
            Açık Rıza Metni
          </div>
        </div>
      </div>

      <hr style={styles.divider} />

      <div style={styles.legalText}>
        <p>
          Bu web sitesinde yer alan tüm yazılım, tasarım, metin, görsel, video
          ve marka unsurları Von Dijital Hizmetler Pazarlama ve Ticaret LTD.
          ŞTİ.’ye aittir ve ilgili mevzuat kapsamında korunmaktadır. İzinsiz
          kopyalanamaz, çoğaltılamaz, dağıtılamaz ve kullanılamaz.
        </p>
        <p>
          <strong>www.temelden.com.tr</strong> üzerinde kullanıcılar tarafından
          sağlanan ilan ve içeriklerin doğruluğu, güvenilirliği ve hukuka
          uygunluğuna ilişkin sorumluluk içerik sağlayan kullanıcıya aittir. Von
          Dijital Hizmetler Pazarlama ve Ticaret LTD. ŞTİ., bu içeriklerden
          doğabilecek herhangi bir sorumluluk kabul etmez.
        </p>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: "#f4f4f4",
    padding: "40px 20px 20px",
    borderTop: "1px solid #ddd",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  column: {
    flex: "1",
    minWidth: "200px",
    marginBottom: "20px",
  },
  heading: {
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "12px",
    color: "#333",
  },
  link: {
    color: "#444",
    textDecoration: "none",
    marginBottom: "8px",
    fontSize: "14px",
    cursor: "pointer",
    transition: "color 0.2s",
  },
  socialIcons: {
    display: "flex",
    gap: "12px",
    marginTop: "8px",
  },
  socialLink: {
    cursor: "pointer",
  },
  icon: {
    width: "24px",
    height: "24px",
  },
  storeBadge: {
    width: "120px",
    height: "auto",
    marginBottom: "8px",
    cursor: "pointer",
  },
  divider: {
    border: "none",
    borderTop: "1px solid #ccc",
    margin: "20px 0 10px",
  },
  legalText: {
    maxWidth: "1200px",
    margin: "0 auto",
    fontSize: "11px",
    color: "#666",
    textAlign: "center",
    lineHeight: "1.6",
  },
};

export default Footer;
